<template>
  <div style="height: 100%;">
  	<div class="room">
      <div class="columns is-mobile is-centered">
        <div class="column is-11">
          <spinner-loading v-if="loading_get_messages"></spinner-loading>
          <pagination v-if="!loading_get_messages" :dataProvider="dataProvider" :clickHandler="getMessages"></pagination>

          <div v-for="(m, i) in messages" :key="i" :class="{'sender': m.userId == auth.id, 'receiver': m.userId != auth.id}">
            <div class="columns is-mobile is-vcentered is-gapless">
              <div class="column">
                <div class="message-item">
                  <pre>{{ m.message }}</pre>
                  <p class="message-time has-text-grey tooltip"
                    :data-tooltip="date_humanize(m.createdAt)"
                  >&nbsp;&nbsp;<em>{{ getTimeOfDate(m.createdAt) }}&nbsp;<i v-if="m.userId == auth.id" class="fas fa-check-double" :class="{'seen': m.status == 'READ'}"></i></em></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <message-input :sendMessage="sendMessage"></message-input>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { MESSAGE } from '~/consts'

export default {
  props: {
    conversation: {
      type: Object,
      required: true
    },
    onSendMessage: {
      type: Function,
      default: () => {}
    }
  },

  mounted() {
    const vm = this;
    vm.getMessages(true)
    vm.listenEvent()
  },

  computed: {
    ...mapState({
      auth: state => state.auth
    })
  },

  watch: {
    conversation() {
      this.getMessages(true)
      this.listenEvent()
    }
  },

  data() {
    return {
      loading_get_messages: false,
      loading_get_messages_refresh: false,
      messages: [],
      dataProvider: {
        page: {
          current: 1
        }
      }
    }
  },

  methods: {
    listenEvent() {
      const vm = this;

      // window.Echo.private(`new-message`)
      // .listen('NewMessageEvent', (e) => {
      //   if (e.data.payload.conversation_id == vm.conversation.id && e.data.user_id != vm.auth.id) {
      //     vm.getMessages(true)
      //   }
      // })
    },
    getMessages(refresh = false) {
      const vm = this

      if (refresh) {
        vm.dataProvider.page['current'] = 1
        vm.loading_get_messages_refresh = true
      } else {
        vm.loading_get_messages = true
      }

      this.$axios.post(MESSAGE.GET_PAGINATED(vm.conversation.id), {
        dataProvider: JSON.stringify(vm.dataProvider)
      }).then(({ data }) => {
        if (data.applicationSystem.code == 0) {
          let messages = data.data.data

          if (!refresh) {
            messages = collect(vm.messages).merge(messages).toArray();
          }

          vm.messages = collect(messages).sortBy('createdAt', 'asc').toArray();
          vm.dataProvider = data.data.dataProvider

          if (refresh) {
            Vue.nextTick(() => {
              vm.scrollToLatest()
            })
          }
        }

        vm.loading_get_messages_refresh = false
        vm.loading_get_messages = false
      }).catch(() => {
        vm.loading_get_messages_refresh = false
        vm.loading_get_messages = false
      })
    },
    sendMessage(text) {
      const vm = this;

      vm.loading_send = true

      this.$axios.post(MESSAGE.SEND(this.conversation.id), {
        message: text,
      })
        .then(({ data }) => {
          if (data.applicationSystem.code == 0) {
            let messages = data.data.data

            vm.messages = collect(messages).sortBy('createdAt', 'asc').toArray();
            vm.dataProvider = data.data.dataProvider

            vm.onSendMessage(data);

            Vue.nextTick(() => {
              vm.scrollToLatest()
            })
          }

          vm.loading_send = false
        }).catch(() => {
          vm.loading_send = false
        })
    },
    scrollToLatest() {
      $('.room').scrollTop($('.room').prop('scrollHeight'))
    }
  }
}
</script>

<style lang="scss" scope>
.room {
	margin: 12px -12px;
	padding: 12px;
	background-color: #EEE7DE;
	overflow: auto;
  position: relative;
  height: calc(100% - 88px);
  background-image: url(/assets/img/room-bg.png);

	.message-item {
    position: relative;
    border-radius: 4px;
    max-width: 80%;

    pre {
  		padding: 2px 6px;
      background: none;
      white-space: normal;
    }
	}

  .message-time {
    font-size: 10px;
    position: absolute;
    bottom: 1px;

    .seen {
      color: rgb(79, 195, 247) !important;
    }
  }

	.receiver {
		margin-bottom: 10px;

		.message-item {
			float: left;
			box-shadow: 0 0.5px 0 0 #ffffff inset, 0 1px 2px 0 rgba(0, 0, 0, 0.08) !important;
      background: white;

      pre {
        font-family: inherit;
      }

      .message-time {
        right: -35px
      }
		}
	}

	.sender {
		display: flow-root;
		margin-bottom: 10px;

		.message-item {
			float: right;
			background: #E0F6C7;
			box-shadow: 0 0.5px 0 0 #ffffff inset, 0 1px 2px 0 rgba(0, 0, 0, 0.08) !important;

      pre {
        font-family: inherit;
      }

      .message-time {
        left: -53px;
      }
		}
	}
}
</style>
